<script setup lang="ts">
interface Props {
  list: {
    name: string;
    list: {
      id: number;
      name: string;
    }[];
  }[];
  required?: boolean;
  label?: string;
  label2?: string;
  id?: string;
}

const model = defineModel();

const props = withDefaults(defineProps<Props>(), {
  id: "formSelect",
  label: "選択",
  label2: "",
});

if (props.required) {
  useValidatable();
}
const isError = ref<boolean>();

function validate() {
  // 必須でなくて値がないとき
  if (!props.required && !model.value) {
    isError.value = false;
    return true;
  }

  // 必須で初期値のまま
  if (model.value == 0) {
    isError.value = true;
    return false;
  }

  // テストに合格
  isError.value = false;
  return true;
}

watchDebounced(
  () => model.value,
  () => {
    // 値がないときは入力時のvalidateを行わない。submit時のvalidateは実行される
    if (model.value) {
      validate();
    }
  },
  { debounce: 500 },
);

defineExpose({ validate });
</script>

<template>
  <div ref="el" class="w-full tablet:max-w-[50%] relative pb-6">
    <FormInputLabel :id="id" :label="label" :label2="label2" />
    <select
      v-model="model"
      class="w-full border rounded p-2"
      :class="isError ? 'bg-red-100 border-red-400' : 'bg-white'"
    >
      <option value="0" disabled>選択してください</option>
      <optgroup v-for="option in list" :key="option.name" :label="option.name">
        <option v-for="o in option.list" :key="o.id" :value="o.id">
          {{ o.name }}
        </option>
      </optgroup>
    </select>
    <FormAlert
      v-if="isError"
      type="error"
      class="flex items-center absolute bottom-0"
    >
      <Icon class="mr-1 text-sm" size="18" name="mdi:alert-circle" />
      <span>選択してください</span>
    </FormAlert>
  </div>
</template>
